/** Home banner for CRM + Marketing members who haven't sent their marketing brief yet. */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Megaphone } from 'lucide-react';
import { wget } from '@/components/website/api';

export default function MarketingOnboardingBanner() {
  const navigate = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { wget('/marketing/onboarding/me').then(setD).catch(() => {}); }, []);
  if (!d?.required || d.doc?.submitted_at) return null;
  return (
    <button type="button" onClick={() => navigate('/marketing/onboarding')}
      className="w-full text-left rounded-xl border-2 border-[#006400]/40 bg-[#006400]/5 hover:bg-[#006400]/10 px-4 py-3 flex items-center gap-3 mt-3 transition-colors" data-testid="home-marketing-onboarding-banner">
      <div className="w-9 h-9 rounded-lg bg-[#006400] text-white flex items-center justify-center shrink-0"><Megaphone className="w-5 h-5" /></div>
      <div className="text-sm min-w-0 flex-1">
        <div className="font-bold text-slate-900">Tell us about your marketing — 2 minutes</div>
        <div className="text-slate-600 text-xs mt-0.5">Your ad budget, areas and goals so the team can start your campaigns straight away.</div>
      </div>
      <ArrowRight className="w-5 h-5 text-[#006400] shrink-0" />
    </button>
  );
}
